$(document).ready(function() {
  
    // bubble kit popup begin
    $('.popup').on('click', function(e) {
        if ($(e.target).closest(".popuptext").length === 0) {
            if($(this).hasClass('active')) {
                $('.popup .popuptext').hide();
                $('.popup').removeClass('active');
                $(this).find('.popuptext').hide();
                $(this).removeClass('active');
            } else {
                $('.popup .popuptext').hide();
                $('.popup').removeClass('active');
                $(this).find('.popuptext').show();
                $(this).addClass('active');
            }
        }
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest(".popup").length === 0 && $(e.target).closest(".popuptext").length === 0) {
            $('.popup .popuptext').hide();
            $('.popup').removeClass('active');
        }
    }); 

    // $('.popup').on('mouseenter', function(e) {
    //     if ($(e.target).closest(".popuptext").length === 0) {
    //             $('.popup .popuptext').hide();
    //             $('.popup').removeClass('active');
    //             $(this).find('.popuptext').show();
    //             $(this).addClass('active');
    //     }
    // });

    // $('.popup').on('mouseleave', function(e) {
    //     if ($(e.target).closest(".popuptext").length === 0) {
    //             $('.popup .popuptext').hide();
    //             $('.popup').removeClass('active');
    //             $(this).find('.popuptext').hide();
    //             $(this).removeClass('active');
    //     }
    // });
    // bubble kit popup emd

    
 
    // Scroll to top arrow begin
    $(".scroll-animate").click(function(e) {
        e.preventDefault();
        var data_minus = $(this).attr('data-animte-minus');
        var targt = $(this).attr('href');
        $('html, body').animate({
            // scrollTop: $(targt).offset().top - data_minus
            scrollTop: 0
        }, 'slow');
    });
    // Scroll to top arrow end

    // PDP Scroll to top arrow on mobile begin
    $(window).scroll(function() {
      if ($('.attain-product-detail-education').length > 0) {
        if($(this).scrollTop() >= $('.attain-product-detail-education')[0].scrollHeight) {
            $('.pdp-top-arrow').show(300);
        }
        else{
          $('.pdp-top-arrow').hide(300);
         }
      }
     });
  // PDP Scroll to top arrow on mobile end
  

    // marquee for the first section
    $('.data-slider:eq(0)').owlCarousel({
        loop: true,
        margin:50,
        nav:true,
        autoWidth:true,
        items:10,
        autoplay: true,
        slideTransition: 'linear',
        autoplayTimeout: 3000,
        autoplaySpeed: 3000,
        smartSpeed: 1000,
        mouseDrag: false,
        touchDrag: false,
    });
    // marquee for the rest two section
    $('.data-slider:not(:eq(0))').owlCarousel({
        loop: true,
        margin:50,
        nav:true,
        autoWidth:true,
        items:10,
        autoplay: true,
        slideTransition: 'linear',
        autoplayTimeout: 5000,
        autoplaySpeed: 5000,
        smartSpeed: 1000,
        mouseDrag: false,
        touchDrag: false,
    });
    // marquee end
  

    // footer menu toggle for responsive
    function footerMenuToggle() {
        if($(window).width() < 992) {
            $('.footer-block--menu .footer-block__heading').on('click', function() {
                $(this).parent().find('ul').slideToggle();
                $(this).toggleClass('open');
            });
        }
    }
    footerMenuToggle();

    // $(window).resize(function() {
    //     footerMenuToggle();
    // });
  
  
   

    // quantity selector in PDP page begin
    var one =  $('#sn-product-widget button:nth-child(1)');
    var sub =  $('#sn-product-widget button:nth-child(2)');
    $(sub).click(function() {
      $(".product-form__quantity").hide();
      $(".product-form__buttons").addClass("full-width");
    });
    $(one).click(function() { 
      $(".product-form__quantity").show();
      $('.product-form__buttons').removeClass("full-width");
    });
    // quantity selector in PDP page end

     // slider product recom begin
    $('.product-recommendations').hide();
    var slideInte = setInterval(function() {
      // console.log('ln', $('.comm-prod .item').length)
      if ($('.comm-prod .item').length < 5) {
        // console.log('ln', $('.comm-prod .item').length)
        $('.comm-prod').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button' style=''><svg width='48' height='20' viewBox='0 0 48 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M-0.000278473 9.99999C-0.000278473 9.75641 0.171967 9.43296 0.346737 9.27601L10.1928 0.328539C10.6525 -0.0779337 11.3973 -0.12504 11.9332 0.287485C12.4123 0.656273 12.4243 1.37553 11.9812 1.776L4.07742 8.94713H46.7692C47.449 8.94713 48 9.41839 48 9.99976C48 10.5811 47.449 11.0525 46.7692 11.0525H4.07742L11.9812 18.2236C12.4242 18.624 12.3928 19.3256 11.9332 19.7121C11.448 20.1201 10.6455 20.0837 10.1928 19.671L0.346737 10.7235C0.0574417 10.4809 0.00458145 10.2471 -0.000278473 9.99999Z' fill='#55253B'/></svg></button>",
          nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button' style=''><svg width='48' height='20' viewBox='0 0 48 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M48.0003 9.99999C48.0003 9.75641 47.828 9.43296 47.6533 9.27601L37.8072 0.328539C37.3475 -0.0779337 36.6027 -0.12504 36.0668 0.287485C35.5877 0.656273 35.5757 1.37553 36.0188 1.776L43.9226 8.94713H1.23078C0.551021 8.94713 0 9.41839 0 9.99976C0 10.5811 0.551021 11.0525 1.23078 11.0525H43.9226L36.0188 18.2236C35.5758 18.624 35.6072 19.3256 36.0668 19.7121C36.552 20.1201 37.3545 20.0837 37.8072 19.671L47.6533 10.7235C47.9426 10.4809 47.9954 10.2471 48.0003 9.99999Z' fill='#55253B'/></svg></button>",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2, 
                slidesToScroll: 2,
                arrows: false
              }
            }
          ]
        });
        $('.product-recommendations').show();
        // setTimeout(function() {
      // clearInterval(slideInte);
        // }, 500);
      }
    }, 500);
    // slider product recom end


  // slider product recom begin
    var slideInteColl = setInterval(function() {
      if ($('.featured-coll').length > 0) {
        $('.featured-coll').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button' style=''><svg width='48' height='20' viewBox='0 0 48 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M-0.000278473 9.99999C-0.000278473 9.75641 0.171967 9.43296 0.346737 9.27601L10.1928 0.328539C10.6525 -0.0779337 11.3973 -0.12504 11.9332 0.287485C12.4123 0.656273 12.4243 1.37553 11.9812 1.776L4.07742 8.94713H46.7692C47.449 8.94713 48 9.41839 48 9.99976C48 10.5811 47.449 11.0525 46.7692 11.0525H4.07742L11.9812 18.2236C12.4242 18.624 12.3928 19.3256 11.9332 19.7121C11.448 20.1201 10.6455 20.0837 10.1928 19.671L0.346737 10.7235C0.0574417 10.4809 0.00458145 10.2471 -0.000278473 9.99999Z' fill='#55253B'/></svg></button>",
          nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button' style=''><svg width='48' height='20' viewBox='0 0 48 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M48.0003 9.99999C48.0003 9.75641 47.828 9.43296 47.6533 9.27601L37.8072 0.328539C37.3475 -0.0779337 36.6027 -0.12504 36.0668 0.287485C35.5877 0.656273 35.5757 1.37553 36.0188 1.776L43.9226 8.94713H1.23078C0.551021 8.94713 0 9.41839 0 9.99976C0 10.5811 0.551021 11.0525 1.23078 11.0525H43.9226L36.0188 18.2236C35.5758 18.624 35.6072 19.3256 36.0668 19.7121C36.552 20.1201 37.3545 20.0837 37.8072 19.671L47.6533 10.7235C47.9426 10.4809 47.9954 10.2471 48.0003 9.99999Z' fill='#55253B'/></svg></button>",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: true,
                dots: true,
                customPaging : function(slider, i) {
                  var thumb = $(slider.$slides[i]).data();
                  console.log('i', typeof(i), i+1)
                  var num = i + 1;
                  return '<a class="dot">'+num+'</a>';
                  }
              }
            }
          ]
        });
      clearInterval(slideInteColl);
      }
    }, 500);
    // slider product recom end

      // Marquee slider
      // var mul_sl = $('.marquee-slider');
      // mul_sl.each(function(num, elem) {
      //     $(this).slick({
      //         arrows: false,
      //         infinite: true,
      //         autoplay: true,
      //         //centerMode: true,
      //         // dots: false,
      //         // slidesToShow: 1,
      //         variableWidth: true,
      //         // slidesToScroll: 2,
      //         speed: 4000,
      //         autoplaySpeed: 0,
      //         cssEase: "linear",
      //         pauseOnhover: false
      //     });
      // });
  
      // var swiperOptions = {
      //     loop: true,
      //     // freeMode: true,
      //     // spaceBetween: 0,
      //     // grabCursor: true,
      //     // slidesPerView: 5,
      //     loop: true,
      //     autoplay: {
      //       delay: 1,
      //       disableOnInteraction: true
      //     },
      //     // freeMode: true,
      //     speed: 5000,
      //     // freeModeMomentum: false
      //   };
        
      //   var swiper = new Swiper(".swiper-container", swiperOptions);
        
      //   $(".swiper-container").mouseenter(function () {
      //     console.log("mouse over");
      //     swiper.autoplay.stop();
      //   });
        
      //   $(".swiper-container").mouseleave(function () {
      //     console.log("mouse leave");
      //     swiper.autoplay.start();
      //   });
        
  
      // var owl = $('.marquee-slider');
      // owl.owlCarousel({
      //     // items:4,
      //     loop:true,
      //     margin:10,
      //     autoplay:true,
      //     autoplayTimeout:1000,
      //     autoplayHoverPause:true
      // });

      // window.SLIDECART_ADD_TO_CART = function({ id, quantity }) {
      // // Fires whenevr slide cart has updated
      // var item_ar = [];
      //   item_ar.push({
      //             quantity: 1,
      //             id: id
      //         });
      // $('.product-form__submit').on('click', function () {
      //     setTimeout(function () {
      
      //         var item_ar = [];
      //         // $(this).parents('form').submit();
      //         if ($('.frequently-together-item input:checked').length > 0) {
      //             $('.frequently-together-item input:checked').each(function () {
      //                 item_ar.push({
      //                     quantity: 1,
      //                     id: $(this).val()
      //                 });
      //             });
      //             data = {
      //                 items: item_ar
      //             }
      //             console.log('af after', data)
      //             $.ajax({
      //                 type: 'POST',
      //                 url: '/cart/add.js',
      //                 dataType: 'json',
      //                 data: data,
      //                 success: function () {
      //                     SLIDECART_UPDATE();
      //                     console.log('called suessss');
      //                     window.location.href = '/';
      //                     window.location.href = '/cart';
      //                 }
      //             });
      //         }
      //     }, 500)
      // });
      // }
      
    function shippingProgress() {
      if ($('.cart-items').length > 0) {
          $.ajax({
            type: 'GET',
            url: window.Shopify.routes.root + "cart.json",
            dataType: 'json',
            cache: false,
            success: function(cartData){
              if ($('.shipping-progress-bar .shipping-progress .free-shipping').length > 0) {
                $('.shipping-progress-bar .shipping-progress .free-shipping').remove();
              }
             let totalPrice = cartData.total_price;
             let compAmt = 10000;
             if(totalPrice >= compAmt){
                console.log('Greater  than equal ',compAmt);
               // $('.shipping-progress-bar').hide();
               $('.shipping-progress-bar').show();
               $('.shipping-progress-bar .shipping-progress .progress').before('<div class="free-shipping"><p style="font-family: Gilroy Light;font-weight: 300;font-size: 16px;line-height: 18px;color: #705619;margin-bottom: 20px !important;">You have FREE SHIPPING!</p></div>');
              let per_progree = 100;
               if($(window).width() <= 767) {
                 $('.progress .progress-bar').css({"width":
                    function() {
                        return per_progree + "%";
                    }
                })
               } else {
                 $('.progress .progress-bar').css({
                  "width": "320px"
                })
               }
             } else{
               $('.shipping-progress-bar').show();
               let diff = compAmt - totalPrice;
               let ActDiff = (diff/100).toFixed(2);
               console.log('you are away ', ActDiff);
               if (ActDiff > 0) {
                 $('.shipping-progress-bar .shipping-progress .progress').before('<div class="free-shipping"><p style="font-family: Gilroy Light;font-weight: 300;font-size: 16px;line-height: 18px;color: #705619;margin-bottom: 20px !important;">You’re $'+ActDiff+' away from FREE SHIPPING!</p></div>');
      
                 let per_progree = 100 - ((ActDiff*100)/100).toFixed(2);
                 console.log('per_progree', per_progree)
                   $('.progress .progress-bar').css({"width":
                      function() {
                          return per_progree + "%";
                      }
                  })
               }
             }
            },
         });
        } else {
             $('.shipping-progress-bar').hide();
        }
    }
    if ($('body').hasClass('template-cart')) {
      shippingProgress();
  
      if ($('.cart__items-wrapper').length > 0) {
        $('.cart__items-wrapper').wrap('<div class="cart-main-row"></div>');
      }
      if ($('.cart__footer-wrapper').length > 0) {
        let footer_div = $('.cart__footer-wrapper').detach();
        $('.cart-main-row').append(footer_div);
      }
    }
  
    if ($(window).width() <= 500) {
      if ($('.assistance-tabs').length > 0) {
        let active_index = $('.assistance-tabs .nav.nav-pills .nav-item.active').index();
        let scroll_to = 0;
        let outerContentWidth = $('.assistance-tabs .nav.nav-pills .nav-item').width();
        if (active_index == 1) {
            scroll_to = Math.ceil(outerContentWidth/2) + 50;
        } else if (active_index == 2) {
            scroll_to = Math.ceil(outerContentWidth) + 60;
        }
        // console.log('scroll_to', scroll_to);
        $('.assistance-tabs .nav.nav-pills').scrollLeft(scroll_to);
      }
    }

  if ($(window).width() <= 991) {
    if ($("header .header-menu-main").length == 0) {
    $('header').wrapInner('<div class="header-menu-main"></div>');
    }
  } else {
    if ($("header .header-menu-main").length > 0) {
      $("header .header-menu-main").contents().unwrap();
    }
  }
  $(window).resize(function() {
    if ($(window).width() <= 991) {
      if ($("header .header-menu-main").length == 0) {
    $('header').wrapInner('<div class="header-menu-main"></div>');
    }
    } else {
      if ($("header .header-menu-main").length > 0) {
        $("header .header-menu-main").contents().unwrap();
      }
    }
  });

    // Search functionality begin
  $('.search-modal__form').on('submit', function(e) {
    e.preventDefault();
    if ($('body').hasClass('strength')) {
      var tag_var = 'strength-product';
    } else {
      var tag_var = 'attain-product';
    }
    var search_con = "/search?q="+$(this).find('#Search-In-Modal').val()+"+tag:"+tag_var+"&options%5Bprefix%5D=last";
    // console.log('search_con', search_con)
    window.location.href = search_con;
  });

  $('.template-search .search').on('submit', function(e) {
    e.preventDefault();
    if ($('body').hasClass('strength')) {
      var tag_var = 'strength-product';
    } else {
      var tag_var = 'attain-product';
    }
    var search_con = "/search?q="+$(this).find('#Search-In-Template').val()+"+tag:"+tag_var+"&options%5Bprefix%5D=last";
    // console.log('search_con', search_con)
    window.location.href = search_con;
  });
  // Search functionality end

  // Hide the price on quiz results page begin
  var quizInterval = setInterval(function() {
    if ($('#quiz-kit-sections-container [id^=quiz-kit-results-product] > div a h3:contains(Color -)').length > 0) {
      $('#quiz-kit-sections-container [id^=quiz-kit-results-product] > div a h3:contains(Color -)').each(function() {
          $(this).parent().next('h4').hide();
      });
      clearInterval(quizInterval);
    }
  }, 500);
  // Hide the price on quiz results page end

  // For keep shopping button on cart page begin
   $('a.back').click(function(){
		parent.history.back();
		return false;
	});
  // For keep shopping button on cart page end

  // Add recommended products manually and redirected to checkout page begin
  document.addEventListener('quizKitResultsPageLoaded', function (e) {
    $('.quiz_page .main-page-title').css('display', 'none');
    $('.quiz_page #quiz-kit-content').css('display', 'none');
    $('.quiz_page #quiz-kit-content').after('<h4 id="preloader" class="text-center">Loading...</h4>');
    // e.detail will contain question data
    var item_quiz_ids = [];
    var item_id = "";
    var item_var_id = "";
    $.each(e.detail.recommendedProducts, function (index, item) {
      if(item.product_type != 'Kits') {
        if(item.variants[0].inventory_quantity > 0) {
          item_quiz_ids.push({
              quantity: 1,
              id: item.variants[0].id
          });
        }
      } else {
        if(item.variants[0].inventory_quantity > 0) {
          item_quiz_ids.push({
              quantity: 1,
              id: item.variants[0].id
          });
        } else {
          item_id = item.id;
          item_var_id = item.variants[0].id;
          item_quiz_ids = [];
          return false;
        }
      }
    });
    data = {
        items: item_quiz_ids
    }
    if (item_quiz_ids.length > 0) {
    // if (e.detail.recommendedProducts.length == item_quiz_ids.length) {
      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: data,
          success: function () {
              console.log('called suessss');
              window.location.href = '/checkout';
              // window.location.href = '/cart';
          }, 
        error: function (jqXHR, exception) {
          window.location.href = '/checkout';
        }
      });
    } else {
        window.location.href = '/pages/kit-out-of-stock?item='+item_id+'&variant='+item_var_id;
    }
  }, false);
  // Add recommended products manually and redirected to checkout page end

  // To show the respective image based on bullet selection begin
  $( '.nav-bullet:not(.nav-bullet-mobile) ul li a' ).on( 'click', function(e){
    // $(window).off('scroll');
    $( '.nav-bullet:not(.nav-bullet-mobile) ul li a' ).removeClass('active');
    var href = $(this).attr( 'href' );
    $(this).addClass('active');
    $( 'html, body' ).animate({
  		scrollTop: $( href ).offset().top - 350
    }, '300' );
    e.preventDefault();
    // $(window).on('scroll');
    // return false;
  });
  // To show the respective image based on bullet selection end

  // To show activate the bullet based on the respective image on scroll begin
  function isVisible($el) {
    // var $el = $('#Slide-template--15988044202164__main-28306891309236');
    var elementTop = $el.offset().top - 350;
    var elementBottom = elementTop + $el.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  }
  $( window ).scroll(function() {
    var el_ind;
    var el;
    $('slider-component ul.product__media-list li').each(function (idx, el) {
    // $($('slider-component ul.product__media-list li').get().reverse()).each(function (idx, el) {
        el = isVisible($(this));
        if (el) {
          el_ind = idx;
          return false;
        }
    }); 
    if (el_ind == undefined){
      el_ind = $('slider-component ul.product__media-list li').length - 1;
    }
    $( '.nav-bullet:not(.nav-bullet-mobile) ul li a' ).removeClass('active');
    $( '.nav-bullet:not(.nav-bullet-mobile) ul li a' ).eq(el_ind).addClass('active')
  });
  // To show activate the bullet based on the respective image on scroll end

  // add class on PDP page when scroll
$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom - 700 > viewportTop && elementTop + 800 < viewportBottom;
};

$(window).on('resize scroll', function() {
  $('.product-detail-page').each(function() {
    if ($(this).isInViewport()) {
     $(".product-detail-page").addClass("scroller");
    } else {
    $(".product-detail-page").removeClass("scroller");
    }
  });
});

  // Back in stock click begin
  
  $('.btn-waitlist').on('click', function (event) {
     event.preventDefault();
    $('.loginError').hide();
    $('.success_msg').hide();
    var email_val = $('#ContactForm-email').val();
    var page_url = window.location.search.replace('?', '').split('&');
    var item_id = page_url[0].split('=');
    var variant_id = page_url[1].split('=');
    console.log(email_val, item_id[1], variant_id[1])
    if (email_val != '') {
    var urlencoded = new URLSearchParams(),
        data = {
            a: "SrDpyY",
            email: email_val,
            variant: variant_id[1],
            product: item_id[1],
            platform: "shopify",
        };
    for (const key in data) {
        urlencoded.append(key, data[key]);
    }
    var requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: urlencoded,
        redirect: "follow",
    };
    fetch(
            "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
            requestOptions
        )
        .then((response) => response.text())
        .then((result) => {
            console.log('suucsees');
             $('.success_msg').show();
        })
        .catch((error) => console.log("error", error));
    }else{
      console.log("error");
      $('.loginError').show();
    }
  });
  // Back in stock click end

  // $('.nav-bullet').before('<div class="nav-bullet-extra"></div>');
  $('.nav-bullet ul').html('');
  $('media-gallery .product__media-list:not(.mobile-product-meida) li.product__media-item').each(function(index, item) {
  $('.nav-bullet-extra a[href="#'+$(this).attr('id')+'"]').parent().clone().appendTo(".nav-bullet ul");
    // $('.nav-bullet ul').append($('.nav-bullet-extra a[href="#'+$(this).attr('id')+'"]').parent());
        // console.log(parseInt(index), parseInt($('.nav-bullet a[href="#'+$(this).attr('id')+'"]').parent().attr('data-index')))
        // $('.nav-bullet a[href="#'+$(this).attr('id')+'"]').addClass('d-none');
    // if ($(this).attr('data-index') != parseInt($('.nav-bullet a[href="#'+$(this).attr('id')+'"]').parent().attr('data-index'))) { console.log(index, 'index'); }
        // $('.nav-bullet li[data-index="'+index+'"]');
        // $('.nav-bullet a[href="#'+$(this).attr('id')+'"]').addClass('inn');
});
  
 if ($('media-gallery .product__media-list:not(.mobile-product-meida) li.product__media-item.product__media-item--variant:not(.is-active)').length > 0) {
    console.log($('media-gallery .product__media-list:not(.mobile-product-meida) li.product__media-item.product__media-item--variant:not(.is-active)').attr('id'));
    $('media-gallery .product__media-list:not(.mobile-product-meida) li.product__media-item.product__media-item--variant:not(.is-active)').each(function() {
        console.log($(this).attr('id'), $('.nav-bullet a[href="#'+$(this).attr('id')+'"]'))
        $('.nav-bullet a[href="#'+$(this).attr('id')+'"]').addClass('d-none');
        $('.nav-bullet a[href="#'+$(this).attr('id')+'"]').parent().addClass('d-none');
        // $('.nav-bullet a[href="#'+$(this).attr('id')+'"]').addClass('inn');
    });
  }

  if ($('.nav-bullet li a:not(.d-none').length == 1) {
    $('.nav-bullet').addClass('d-none');
  } else {
    $('.nav-bullet').removeClass('d-none');
  }

  $( '.nav-bullet.nav-bullet-mobile ul li a' ).on( 'click', function(e){
    // e.preventDefault();
    
      $( '.nav-bullet.nav-bullet-mobile ul li a' ).removeClass('active');
    $(this).addClass('active');
    // $('media-gallery .product__media-list li').removeClass('is-active');
    console.log($('media-gallery .product__media-list li[id="'+$(this).attr('href').replace('#', '')+'"]'), 'ele')
    // $('media-gallery .product__media-list li[id="'+$(this).attr('href').replace('#', '')+'"]').addClass('is-active');
    // setTimeout(function() {      
    //   if ($( '.nav-bullet.nav-bullet-mobile ul li:first-child a' ).hasClass('active')) {
    //     console.log('ifff called')
    //     $(".product__media-wrapper slider-component .slider.slider--mobile").scrollLeft(0);
    //   }
    // }, 500);
  });
  $( '.nav-bullet.nav-bullet-mobile ul li a' ).removeClass('active');
  $( '.nav-bullet.nav-bullet-mobile ul li:first-child a' ).addClass('active');

  $('.product__media-wrapper slider-component .slider.slider--mobile').scroll(function() {
    $('.nav-bullet.nav-bullet-mobile li a').parent().siblings('li:not(.d-none)').each(function(index, item) {
        console.log(index+1, parseInt($('.slider-counter--current').text()) )
        if (index+1 == parseInt($('.slider-counter .slider-counter--current').html())) {
            $(this).find('a').trigger('click');
        }
    });        
  });
      
});
